module.exports = __webpack_public_path__ + "static/img/home_product2.1675b332.png";